import { TakeALook } from "components/TakeALook/TakeALook";
import { YoullLikeList } from "components/YoullLikeList/YoullLikeList";
import { observer } from "mobx-react-lite";
import { store } from "store/index.store";

import { Carrousel } from "./Carrousel/Carrousel";

import "./HomePage.scss";
import { useEffect } from "react";
import { Alert } from "antd";

export const HomePage = observer(() => {
  const { homePageStore } = store;

  const { fetchYouWillLikeItems, fetchTakeALookItems } = homePageStore;

  useEffect(() => {
    fetchYouWillLikeItems();
    fetchTakeALookItems();
  }, []);

  return (
    <div className="c-home-page">
      <Alert
        type="warning"
        message={`This is a demo site, no real purchases can be made at the moment. Stay tuned. \n For beta whitelist contact us at: watugotbeta@gmail.com - we will progressively add users until the grand opening in May 1st`}
        banner
        style={{ whiteSpace: "pre-line" }}
      />
      <Carrousel />

      <YoullLikeList />

      <TakeALook />
    </div>
  );
});
